import { processActivitiesTable as processActivitiesTableDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type ActivityTableProps = {
    sortState?: string;
}

export const activitiesTable = ({
    sortState,
}: ActivityTableProps) => {
    return processActivitiesTableDiagram(sortState);
};
